export default "__VITE_ASSET__Bk77EWql__"